import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Button,
  Grid,
  TextField,
  Typography,
  LinearProgress,
  CircularProgress,
} from "@mui/material";
import { Pagination } from '@mui/material';
import Moment from "moment";
import ProgramDisplayer from "../program/programDisplayer";
import config from "../config.json";
import { apiRequest } from "../functions/apiRequest";
const token = localStorage.getItem("token");
const userID = parseInt(localStorage.getItem("userID"));
const id = parseInt(localStorage.getItem("id"));

// const catcolor = {
//   "Water Cred$": "blue",
//   "Human Cred$": "	#A0522D",
//   "Kid Cred$": "#ffc61a",
//   "Social Cred$": "#ff7b00",
//   "Green Cred$": "	#25D366",
//   "Life Cred$": "red",
//   "Learning Cred$": "#ff861c",
//   "Job Cred$": "yellow",
// };

function Dashboard() {
  const stringifiedUser = localStorage.getItem("user");
  const user = JSON.parse(stringifiedUser);
  const [acts, setAct] = useState([]);
  const [select, setSelect] = useState({
    btn1: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor1,
    btn2: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
    btn3: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
    btn4: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
  });
  const [selectionType, setSelectionType] = useState(1);
  const [totalCredit, setTotalCredit] = useState(0);
  const [totalDebit, setTotalDebit] = useState(0);
  const [program, setProgram] = useState(1);
  const [isLoading, setisLoading] = useState(true);
  const [showEvents, setshowEvents] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pages, setpages] = useState(0);
  const [items, setitems] = useState(0);
  const [display, setdisplay] = useState([]);
  const [isCircularProgress, setCircularProgress] = useState(false);

  useEffect(() => {
    if (!token) window.location.href = "/login";
    localStorage.setItem("pic", user["profile_pic"]);
    getAllPrograms(1, 1);

    async function getData() {
      try {
        const body = JSON.stringify({ id: id });
        let res = await apiRequest(
          "GET",
          body,
          `/cred/total?user_id=${userID}`,
          token
        );
        setTotalDebit(res[0].total_debit);
        setTotalCredit(res[0].total_credit);
      } catch (error) {
        setTotalCredit(0);
        setTotalDebit(0);
      }
    }
    getData();
    // eslint-disable-next-line
  }, []);

  const handleProgramSelection = async (type) => {
    try {
      document.getElementById("searchId").value = "";
      const buttonColors = {
        btn1: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
        btn2: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
        btn3: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
        btn4: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
      };
      buttonColors[`btn${type}`] =
        config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor1;

      setCircularProgress(true);
      setCurrentPage(1);
      setSelect(buttonColors);
      setProgram(type);
      setshowEvents(type === 3 || type === 4);
      setSelectionType(type);
      await getAllPrograms(type, 1);
    } catch (error) {
      console.error(`Error in ${type}:", error`);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint =
          program === 1
            ? `/api/landing/page?user_id=${userID}`
            : program === 2
            ? `/api/landing/page`
            : program === 3
            ? `/api/landing/page?user_id=${userID}`
            : program === 4
            ? `/api/landing/page`
            : null;

        const res = await fetch(process.env.REACT_APP_API_URL + endpoint, {
          method: "GET",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify(),
        });

        const data = await res.json();
        if (program === 1) {
          setpages(
            Math.ceil(data.response.response_data[0].Founded_Programs / perPage)
          );
        }
        if (program === 2) {
          setpages(
            Math.ceil(data.response.response_data[0].Programs / perPage)
          );
        }
        if (program === 3) {
          setpages(
            Math.ceil(data.response.response_data[0].Founded_Events / perPage)
          );
        }
        if (program === 4) {
          setpages(Math.ceil(data.response.response_data[0].Events / perPage));
        }
      } catch (error) {}
    };
    fetchData();
  }, [program]);

  const perPage = 20;

  async function getAllPrograms(type, cp) {
    try {
      let endPoint = `/dashboard-data/programs?user_id=${userID}`;
      if (parseInt(type) === 2) {
        endPoint = `/dashboard-data/programs`;
      }
      if (parseInt(type) === 3) {
        endPoint = `/dashboard-data/events?&user_id=${userID}`;
      }
      if (parseInt(type) === 4) {
        endPoint = `/dashboard-data/events`;
      }
      const body = JSON.stringify({ id: id });
      let filteredData = await apiRequest("GET", body, endPoint, token);

      if (filteredData && filteredData.length > 0) {
        dataDisplayer(filteredData, cp);
        setAct(filteredData);
        setisLoading(false);
      } else {
        setpages(0);
        setdisplay([]);
        console.error("No data received from the API");
        setisLoading(false);
      }
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  }

  const dataDisplayer = async (info, cp) => {
    if (info.length > 0) {
      const itemsPerPage = 20;
      const startIndex = (cp - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const slicedData = info.slice(startIndex, endIndex);
      setCircularProgress(false);
      setdisplay(slicedData);
    } else {
      setdisplay([]);
      console.error("No data to display");
    }
  };

  const handlePageChange = async (event, value) => {
    if (currentPage !== value) {
      dataDisplayer(acts, value);
    }
    setCurrentPage(value);
    const body = document.querySelector("#root");
    const numberofitems = items;
    const scrollDuration = numberofitems > 10 ? 3000 : 100;
    body.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
    await new Promise((resolve) => setTimeout(resolve, scrollDuration));
  };

  const handleChange = async (e) => {
    let searchEndPoint = `/search/programs/detail?user_id=${userID}&title=${e.target.value}`;
    if (parseInt(program) === 2) {
      searchEndPoint = `/search/programs/detail?title=${e.target.value}`;
    }
    if (parseInt(program) === 3) {
      searchEndPoint = `/search/events?&title=${e.target.value}&user_id=${userID}`;
    }
    if (parseInt(program) === 4) {
      searchEndPoint = `/search/events?&title=${e.target.value}`;
    }
    const body = JSON.stringify({ id: id });
    try {
      let res = await apiRequest("GET", body, searchEndPoint, token);
      setCurrentPage(1);
      setpages(Math.ceil(res.count / perPage));
      setitems(res.data.length);
      setAct(res.data);
      await dataDisplayer(res.data, 1);
    } catch (error) {
      console.error("Error searching data", error);
    }
  };

  if (!isLoading) {
    return (
      <div style={{ fontFamily: "Raleway" }}>
        <Grid container>
          <Grid item md={12} xs={12}>
            <Card
              style={{
                backgroundColor:
                  config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
              }}
            >
              <CardContent
                style={{ textAlign: "center", verticalAlign: "center" }}
              >
                <Grid
                  container
                  style={{
                    justifyContent: "space-around",
                    verticalAlign: "center",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: 20,
                      textAlign: "left",
                      fontFamily: "Raleway",
                      color:
                        config[process.env.REACT_APP_HOST_NAME].css
                          .dashboardFontColor,
                    }}
                  >
                    {" "}
                    Welcome back, <strong>{user["first_name"]}</strong>
                  </Typography>
                  <Typography
                    style={{
                      fontSize: 20,
                      textAlign: "left",
                      fontFamily: "Raleway",
                      color:
                        config[process.env.REACT_APP_HOST_NAME].css
                          .dashboardFontColor,
                    }}
                  >
                    {" "}
                    Clocked hours: {totalCredit + totalDebit}
                    {/* //change this */}
                  </Typography>
                  <div>
                    <Typography
                      style={{
                        fontSize: 20,
                        textAlign: "right",
                        fontFamily: "Raleway",
                        color:
                          config[process.env.REACT_APP_HOST_NAME].css
                            .dashboardFontColor,
                      }}
                    >
                      {" "}
                      Making a difference since <br></br>{" "}
                      <strong>
                        {user["created_at"]
                          ? Moment(user["created_at"]).format("DD MMMM, YYYY")
                          : ""}{" "}
                      </strong>
                    </Typography>
                  </div>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            container
            justifyContent="center"
            style={{ marginTop: 20, marginBottom: 20 }}
            spacing={1}
          >
            <Grid
              item
              xs={5}
              md={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                style={{
                  width: "100%",
                  height: 40,
                  textTransform: "none",
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css
                      .dashboardFontColor,
                  fontSize: 16,
                  backgroundColor: select.btn1,
                  borderRadius: 100,
                  fontFamily: "Raleway",
                }}
                onClick={() => handleProgramSelection(1)}
              >
                My Programs
              </Button>
            </Grid>
            <Grid
              item
              xs={5}
              md={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                style={{
                  width: "100%",
                  height: 40,
                  textTransform: "none",
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css
                      .dashboardFontColor,
                  fontSize: 16,
                  backgroundColor: select.btn2,
                  borderRadius: 50,
                  fontFamily: "Raleway",
                }}
                onClick={() => handleProgramSelection(2)}
              >
                Explore Programs
              </Button>
            </Grid>
            <Grid
              item
              xs={5}
              md={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                style={{
                  width: "100%",
                  height: 40,
                  textTransform: "none",
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css
                      .dashboardFontColor,
                  fontSize: 16,
                  backgroundColor: select.btn3,
                  borderRadius: 100,
                  fontFamily: "Raleway",
                }}
                onClick={() => handleProgramSelection(3)}
              >
                My Events
              </Button>
            </Grid>
            <Grid
              item
              xs={5}
              md={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                style={{
                  width: "100%",
                  height: 40,
                  textTransform: "none",
                  color:
                    config[process.env.REACT_APP_HOST_NAME].css
                      .dashboardFontColor,
                  fontSize: 16,
                  backgroundColor: select.btn4,
                  fontFamily: "Raleway",
                  borderRadius: 100,
                }}
                onClick={() => handleProgramSelection(4)}
              >
                Explore Events
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}></Grid>
          <Grid item md={3} xs={1}></Grid>

          <Grid item xs={10} md={6} style={{ textAlign: "center" }}>
            <TextField
              fullWidth
              size="small"
              onChange={handleChange}
              style={{ borderRadius: 20 }}
              label="Search"
              variant="outlined"
              id="searchId"
            ></TextField>
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            EARN= Earn time cred$ &nbsp;&nbsp;&nbsp;&nbsp; BURN = Give time
            cred$
          </Grid>

          {isCircularProgress ? (
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "40vh",
                margin: "auto",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              <ProgramDisplayer
                data={display}
                isEvent={showEvents}
                type={selectionType}
                callBackFun={getAllPrograms}
              />
              <Pagination
                count={pages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                style={{
                  marginTop: 20,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </>
          )}
        </Grid>
      </div>
    );
  } else {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <img
          alt={"logo"}
          style={{ height: 350, width: 300 }}
          src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`}
        />
        <LinearProgress />
      </div>
    );
  }
}

export default Dashboard;
